

// base_search 1.3
import { ChevronDown, ChevronRight, Filter } from "lucide-react"
import { Input, Button, MainModal, Form, Row, Col, Checkbox, Modal, Typography } from './ot'
import { useState, useEffect } from "react"
import AdvancedSearchForm from "./advanced_search_form"
const AdvancedSearchModal = ({
    items = [
        {
            label: "文案名稱",
            name: "name",
            type: "text"
        },
        {
            label: "文案描述",
            name: "description",
            type: "text"
        },
        {
            label: "建立時間",
            name: "create_time",
            type: "date_range",
        },
        {
            label: "瀏覽次數",
            name: "view_times",
            type: "number_range",
        },
        {
            label: "發布形式分類",
            name: "selection_option",
            type: "select",
        }
    ],
    value,
    onFormFinish = () => { },
    onCancel,
    visible,
    ...props
}) => {
    const [open, setOpen] = useState(false);
    const [form] = Form.useForm();

    const handleClearAll = () => {
        form.resetFields()
    };
    const closeModal = () => {
        setOpen(false);
    }
    const handleOk = (values) => {
        onFormFinish(values)
        setOpen(false);
    };
    const handleCancel = () => {
        closeModal()
    };
    return (<>
        <Button
            variant="outline"
            size="sm"
            onClick={() => {
                setOpen(true)
            }}>
            <>  進階查詢</>
        </Button>
        <Modal
            open={open}
            title={<div  >  進階查詢</div>}
            width={800}
            onOk={handleOk}
            // onCancel={handleCancel}
            confirmLoading={false}
            maskClosable={false}
            contentStyle={{
                padding: 8,
            }}
            okText={"確定"}
            cancelText={"取消"}
            footer={<Col span={24}>
                <Row justify={"space-between"}>
                    <Col>
                        <Button
                            onClick={()=>handleClearAll()}
                            type="default" >
                            清除條件
                        </Button>
                    </Col>
                    <Col>
                        <Row gutter={[4, 4]}>
                            <Col>
                                <Button
                                    onClick={()=>closeModal()}
                                    type="default">
                                    取消

                                </Button>
                            </Col>
                            <Col>
                                <Button
                                    onClick={() => {
                                        form.submit()
                                    }}
                                >
                                    套用篩選
                                </Button>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </Col>}
        >
            <Row>
                <Col span={24}>
                    <AdvancedSearchForm
                        propsForm={form}
                        items={items}
                        onFormFinish={(value) => {
                            handleOk(value)
                        }}
                    />
                </Col>
            </Row>
        </Modal>
    </>)
}

export default AdvancedSearchModal